import * as R from 'ramda';

const facebookLocationNotConnected = ({ facebookData, facebookPageData }) => {
    return (R.isNil(facebookData) || R.isEmpty(facebookData)) && R.isNil(facebookPageData);
};

export default facebookLocationNotConnected;